import { PracticeMappingHandler } from '../../../mappings/practices';

export class CorePracticePracticeMappingHandler extends PracticeMappingHandler {}
